import { TAGS } from "../constants";
import { Intake, VisitType } from "../types";
import { api } from "./api";

export const intakesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getIntakes: builder.query<
      Intake[],
      { productSlug?: string; active?: boolean }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/intakes`,
        params: {
          active: params.active ?? undefined,
        },
      }),
      providesTags: [TAGS.INTAKES],
    }),
    createIntake: builder.mutation<
      Intake,
      {
        visit_type: VisitType;
        active: boolean;
        product_id: number;
        product_slug: string;
        product_category_id: number;
      }
    >({
      query: (body) => ({
        url: `/api/intakes`,
        method: "POST",
        body: {
          visit_type: body.visit_type,
          active: body.active,
          product_id: body.product_id,
          product_category_id: body.product_category_id,
        },
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const { data } = await queryFulfilled;

        dispatch(
          intakesApi.util.updateQueryData(
            "getProductIntakes",
            { productId: args.product_slug },
            (draft) => {
              draft[draft.length] = data;
            },
          ),
        );
      },
    }),
    getProductIntakes: builder.query<
      Intake[],
      { productId?: string; params?: { active?: boolean } }
    >({
      query: ({ productId, params }) => ({
        method: "GET",
        url: `/api/products/${productId}/intakes`,
        params,
      }),
      providesTags: (_returns, _error, args) => [
        { type: TAGS.PRODUCT_INTAKES, id: args.productId },
      ],
    }),

    updateIntake: builder.mutation<
      Intake,
      {
        id: number;
        product_slug: string;
        body: { active?: boolean; first_question?: string };
      }
    >({
      query: ({ id, body }) => ({
        url: `/api/intakes/${id}`,
        method: "PUT",
        body,
      }),
      onQueryStarted: async (args, { dispatch, queryFulfilled }) => {
        const patch = dispatch(
          intakesApi.util.updateQueryData(
            "getProductIntakes",
            { productId: args.product_slug },
            (draft) => {
              for (let i = 0; i < draft.length; i++) {
                if (draft[i].id === args.id && args.body.active != null) {
                  draft[i].active = args.body.active;
                  break;
                }
                if (
                  draft[i].id === args.id &&
                  args.body.first_question != null
                ) {
                  draft[i].first_question.slug = args.body.first_question;
                  break;
                }
              }
            },
          ),
        );

        queryFulfilled.catch(patch.undo);
      },
    }),
  }),
});

export const {
  useGetProductIntakesQuery,
  useUpdateIntakeMutation,
  useCreateIntakeMutation,
  useGetIntakesQuery,
} = intakesApi;
